import * as React from "react";
import { Table } from "components/bootstrap";
import { PaginatedList, Spinner } from "components/common";
import useEventNotifications from "components/event-notifications/hooks/useEventNotifications";
import { usePagination, useSetPagination } from "common/contexts";
import Center from "components/common/Center";
import ListHeader from "./ListHeader";
import ListRows from "./ListRows";
function List({ notificationId, setNotificationId }) {
  const localPagination = usePagination();
  const setLocalPagination = useSetPagination();
  const { data: paginatedEventNotifications, isInitialLoading: isLoadingEventNotifications } = useEventNotifications({
    query: "",
    page: localPagination.page,
    pageSize: localPagination.perPage,
    sort: {
      attributeId: "title",
      direction: "asc"
    }
  });
  const onPageChange = (newPage, newPageSize) => {
    setLocalPagination({ ...localPagination, page: newPage, perPage: newPageSize });
  };
  return /* @__PURE__ */ React.createElement("div", null, isLoadingEventNotifications ? /* @__PURE__ */ React.createElement(Center, null, /* @__PURE__ */ React.createElement("div", { "aria-label": "Spinner" }, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Notifications ..." }))) : /* @__PURE__ */ React.createElement(
    PaginatedList,
    {
      activePage: localPagination.page,
      pageSize: localPagination.perPage,
      onChange: onPageChange,
      totalItems: paginatedEventNotifications == null ? void 0 : paginatedEventNotifications.pagination.total,
      useQueryParameter: false
    },
    /* @__PURE__ */ React.createElement(Table, { condensed: true, hover: true, className: "table table-striped" }, /* @__PURE__ */ React.createElement(ListHeader, null), /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement(
      ListRows,
      {
        notificationOptions: paginatedEventNotifications.list,
        notificationId,
        setNotificationId
      }
    )))
  ));
}
export default List;
